import styled, { css, keyframes } from 'styled-components';
import { Tab, VerticalTabWrapper, VerticalTabContent } from '../VerticalTab/styles';
import TextField from '../TextField';

export const SubjectField = styled(TextField)`
  display: flex;
  margin: 0;
  width: 100%;

  & > input {
    margin-top: 5px;
    margin-bottom: 10px;
  }
`;

export const Heading = styled.span`
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
`;

export const OuterWrapper = styled(VerticalTabWrapper)`
  background-color: ${({ theme }) => theme.colors.standardBlackBackground};
  top: 300px;
  height: calc(100% - 300px);

  ${VerticalTabContent} {
    margin-left: -22px;
  }
`;

export const AIHelperTab = styled(Tab)`
  top: 300px;
  background-color: ${({ theme }) => theme.colors.standardBlackBackground};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const GalleryWrapper = styled(Wrapper)`
  margin: 20px 0;
`;

export const SettingsWrapper = styled(Wrapper)`
  & > div {
    justify-content: flex-end;
  }

  & > div:not(:last-of-type) {
    margin-right: 10px;
  }
`;

const rotating = keyframes`
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
`;

export const Placeholder = styled.div`
  width: 21px;
  height: 21px;
  position: relative;
  background-size: 21px 21px;
  animation: ${rotating} 2s linear infinite;
  margin-right: 20px;

  ${({ icon }) =>
    icon &&
    css`
      background-image: url(${icon});
    `}
`;
